import { FC, useState } from "react";
import Button from "src/components/ui/widget/Button";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import KycApprovedModal from "src/components/kyc/kycModals/KycApprovedModal";
import RejectionModal from "src/components/kyc/kycModals/RejectionModal";
import { useLoading } from "src/hooks";
import VerificationService from "src/service/VerifyService";
import ImageMagnifier from "src/components/kyc/ImageMagnifier";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";

const ImagePopUp: FC<{
  urlLink: string;
  isImage: Boolean;
  setImage: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ urlLink, isImage, setImage }) => {
  return (
    <div className={`w-screen h-screen bg-black bg-opacity-70 fixed top-0 left-0 ${isImage ? 'flex' : 'hidden'} flex-col items-center justify-center z-10`}>
      <div className="flex justify-end w-full fixed right-8 top-8"> <span onClick={() => setImage(!isImage)} className="bg-white p-4 rounded-full text-black">X</span></div>
      <div className="h-1/2">
        <img className="h-full" src={urlLink} alt="Image" />
      </div>
    </div>
  );
};

export default ImagePopUp;
